// FilterDropdown — the themed inline filter control used by the By Fund toolbar:
// a funnel pill (icon + label + current value + caret) that opens a tokenised
// popover menu (reusable Dropdown) instead of the browser-native <select> popup.
// Keeps the design's inline-pill layout while matching the app's theme/palette.
import PropTypes from 'prop-types';
import { Dropdown } from '../../../reusable';
import { cx } from '../../../../utils/cx';
import { FunnelIcon, CaretIcon, CheckIcon } from '../../../icons/Icons';

export function FilterDropdown({ label, value, options, onChange, menuClassName }) {
  const selected = options.find((o) => o.value === value) || options[0];

  return (
    <Dropdown
      align="left"
      portal
      className="holdings-filter"
      menuClassName={menuClassName}
      trigger={({ open, toggle }) => (
        <button
          type="button"
          className={cx('holdings-filter__trigger', open && 'is-open')}
          onClick={toggle}
          aria-haspopup="listbox"
          aria-expanded={open}
        >
          <span className="holdings-filter__label">
            <FunnelIcon /> {label}
          </span>
          <span className="holdings-filter__value">{selected?.label}</span>
          <CaretIcon className="holdings-filter__caret" />
        </button>
      )}
    >
      {({ close }) => (
        <ul className="holdings-filter__menu" role="listbox" aria-label={label}>
          {options.map((o) => (
            <li key={o.value}>
              <button
                type="button"
                role="option"
                aria-selected={o.value === value}
                className={cx('holdings-filter__option', o.value === value && 'is-active')}
                onClick={() => {
                  onChange(o.value);
                  close();
                }}
              >
                <span className="holdings-filter__option-label">{o.label}</span>
                {o.value === value && <CheckIcon className="holdings-filter__check" />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </Dropdown>
  );
}

FilterDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.node.isRequired,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  /** Extra class for the popover menu (used to lift it above the mobile sheet). */
  menuClassName: PropTypes.string,
};

export default FilterDropdown;
